<template>
  <div class="menu-bar">
    <div class="icons-main">
      <div class="icon-visibility-container">
        <div
          class="icon icon-main-md"
          @click="navigateTo({ name: 'landing' })"
        ></div>
      </div>
    </div>

    <div v-show="loggedIn" class="icons-nav collapseable">
      <buttonc
        v-for="(icon, i) in iconsNav"
        type="menu"
        :key="i"
        :icon="icon.icon"
        :label="icon.label"
        :link="icon.link"
        :active="isActive(icon.link)"
        @click="navigateTo(icon.link)"
      />
      <buttonc
        class="collapsed"
        type="menu"
        icon="fa-cog"
        label="Menü"
        @click="ToggleDropDown($event, iconsNav, 0, 10)"
      />
    </div>
    <div class="icons-left" v-show="loggedIn"></div>
    <div v-if="loggedIn || loggedInNoCompanies" class="login">
      <!--            <dropdownsearch :state="dropdownStoreState" style="width: 230px; margin: 0px 8px;"/>-->
      <!--<buttonc v-if="storeFilterVisible" type="menu" label="" icon="fa-store" @click="showStoreFilter"/>-->

      <!--            <div class="dividerh"></div>-->

      <div
        v-if="!loggedInNoCompanies"
        class="fas fa-lightbulb"
        role="button"
        @click="toggleDarkMode()"
      ></div>

      <div class="dividerh"></div>

      <div class="menu" v-on:click="OpenUserMenu($event)">
        <employeepicture :pictureUrl="my_image" />
        <div
          v-if="eventNumber > 0"
          class="notification"
          v-bind:class="{ big: eventNumber > 99 }"
        >
          {{ eventNumber }}
        </div>
      </div>
    </div>

    <dropdownlogin ref="dropdownlogin" />
    <dropdown
      ref="dropdown"
      v-for="(dropdown, i) in dropdowns"
      :dropdown="dropdown"
      :key="i"
    />

    <iframe
      id="authframe"
      style="display: none"
      src="https://account.meindienstplan.at/lsproxy.html"
      width="10"
      height="10"
    >
      <!-- Auth IFrame -->
    </iframe>
    <b-modal ref="modal-startup" @close="closeStartupModal()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">Hinweis zu Ihrem Browser</div>
        </div>
      </template>
      <b-container fluid>
        <b-row class="my-1" style="text-align: left">
          <div>
            <span
              ><b
                >ACTHUNG: Manche Features funktionieren in Ihrem Browser
                möglicherweise nicht korrekt!</b
              ><br /><br />Sieht aus als würden Sie Safari verwenden,
              MEINDIENSTPLAN Web ist für Google Chrome optimiert da dieser
              Browser für alle Plattformen verfügbar ist und die größte
              Verbreitung aufweist.<br /><br />Um alle Funktionen optimal nutzen
              zu können verwenden Sie bitte Google Chrome.</span
            >
          </div>
        </b-row>
      </b-container>
      <template slot="modal-footer">
        <div class="button green right" @click="closeStartupModal()">
          <div class="label">Verstanden</div>
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="modal-nopermissions"
      @close="closeNoPermissionsModal()"
      centered
    >
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">Keine Berechtigung</div>
        </div>
      </template>
      <b-container fluid>
        <b-row class="my-1" style="text-align: left">
          <div>
            <span
              >Sie haben nicht die notwendige Benutzerrolle um einen Betrieb in
              MEIN<b>DIENSTPLAN</b> zu öffnen. Ein Administrator Ihres
              Unternehmens kann Ihnen die notwendigen Benutzerrollen für Ihre
              Betriebe zuweisen.</span
            >
          </div>
        </b-row>
      </b-container>
      <template slot="modal-footer">
        <div class="button green right" @click="closeNoPermissionsModal()">
          <div class="label">Verstanden</div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import dropdown from "./uicomponents/dropdown.vue";
import dropdownlogin from "./uicomponents/dropdownlogin.vue";
import dropdownsearch from "./uicomponents/dropdownsearch.vue";
import VueEventBus from "../vue-event-bus";
import { mapState, mapGetters } from "vuex";
import { loadavg } from "os";
import { parse } from "querystring";

export default {
  name: "MenuBar",
  components: {
    dropdown,
    dropdownlogin,
    dropdownsearch,
  },
  data() {
    return {
      warningShown: false,
      loggedInNoCompanies: false,
      authValidity: 86400, // 24 hours
      localStorageSupported: false,
      my_image:
        "https://fileserver1.meindienstplan.de/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S",
      fixedMainIcon: true,
      dropdownStoreState: {},
      dropdowns: [],
      processed: [],
      toggled: false,
      iconsMainCollapsed: false,
      eventNumber: 0,
      authFrame: null,
      selectedStores: [],
      user: {
        items: [
          {
            label: "Mein Account",
            externalLink: "https://account.meindienstplan.at",
          },
        ],
      },
      OnlineUserState: {
        type: "datafill",
        header: "Online:",
        tooltip: true,
        componentState: {
          displayOnly: true,
          entries: {},
        },
      },
      storeFilterVisible: true,
    };
  },
  computed: {
    ...mapGetters([
      "companyId",
      "isSuperUser",
      "loggedIn",
      "userInfo",
      "activeStoreUsersMap",
      "companyArray",
      "storeArray",
    ]),
    activeStoreUsers() {
      return Object.values(this.activeStoreUsersMap).filter(
        (entry) => entry.id != this.userInfo.id
      );
    },
    loginUrl() {
      if (window.location.href.includes("localhost")) {
        return "https://account.meindienstplan.at/#/?redirect=localpromo";
      }

      let sub = this.getSubDomain();
      if (sub === "staging") {
        return "https://account.meindienstplan.at/#/?redirect=stagingpromo";
      } else if (sub === "development") {
        return "https://account.meindienstplan.at/#/?redirect=devpromo";
      }
      return "https://account.meindienstplan.at/#/?redirect=promo";
    },
    computedIconsMain() {
      let sub = this.getSubDomain();
      let urls = [];
      if (sub === "staging") {
        urls = [
          "https://account.meindienstplan.at/#/?redirect=devmdpl",
          "https://account.meindienstplan.at/#/?redirect=stagingmzlogin",
          "https://account.meindienstplan.at/#/?redirect=stagingmplogin",
          "https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin",
        ];
      } else if (sub === "development") {
        urls = [
          "https://account.meindienstplan.at/#/?redirect=devmdpl",
          "https://account.meindienstplan.at/#/?redirect=stagingmzlogin",
          "https://account.meindienstplan.at/#/?redirect=stagingmplogin",
          "https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin",
        ];
      } else {
        urls = [
          "https://account.meindienstplan.at/#/?redirect=mdpl",
          "https://account.meindienstplan.at/#/?redirect=mzlogin",
          "https://account.meindienstplan.at/#/?redirect=mplogin",
          "https://account.meindienstplan.at/#/?redirect=mdcorelogin",
        ];
      }

      let iconsMain = [
        {
          icon: "icon-main-md",
          label: "Mein Dienstplan",
          externalLink: urls[0],
        },
        {
          icon: "icon-main-mz",
          label: "Meine Zeiterfassung",
          externalLink: urls[1],
        },
        { icon: "icon-main-mp", label: "Mein Player", externalLink: urls[2] },
        { icon: "fa-user", label: "Mein Kundencenter", externalLink: urls[3] },
      ];

      return iconsMain;
    },
    userFullname: function () {
      if (this.userInfo.firstname && this.userInfo.lastname) {
        return this.userInfo.firstname + " " + this.userInfo.lastname;
      } else {
        return "User";
      }
    },
    iconsNav: function () {
      let menu = [
        {
          label: "Datei-Verwaltung",
          icon: "fa-folder",
          link: {
            name: "filesMain",
            params: {
              companyId: this.$store.state.companyId,
              tab: "promotions",
            },
          },
        },
        {
          label: "Einstellungen",
          icon: "fa-cog",
          link: {
            name: "company",
            params: {
              companyId: this.$store.state.companyId,
              tab: "userroles",
            },
          },
        },
      ];
      if (this.isSuperUser) {
        menu.push({
          onlyAdmin: true,
          label: "Adminbereich",
          icon: "fa-user-shield",
          link: {
            name: "admin",
            params: { companyId: this.$store.state.companyId, tab: "todo" },
          },
        });
      }
      return menu;
    },
    iconsNavCollapsed: function () {
      let menu = [
        {
          label: "Datei-Verwaltung",
          icon: "fa-folder",
          link: {
            name: "filesMain",
            params: {
              companyId: this.$store.state.companyId,
              tab: "promotions",
            },
          },
        },
        {
          label: "Einstellungen",
          icon: "fa-cog",
          link: {
            name: "company",
            params: {
              companyId: this.$store.state.companyId,
              tab: "userroles",
            },
          },
        },
      ];
      if (this.isSuperUser) {
        menu.push({
          onlyAdmin: true,
          label: "Adminbereich",
          icon: "fa-user-shield",
          link: {
            name: "admin",
            params: { companyId: this.$store.state.companyId, tab: "todo" },
          },
        });
      }
      return menu;
    },
  },
  watch: {
    companyId(newVal, oldVal) {
      if (newVal) {
        this.$helpers.GetStoresSettings();
        this.loadRoles();
        this.checkSuperUser();
      }
    },
    loggedIn(newVal, oldVal) {
      if (newVal) {
        this.loadRoles();
        this.loadUserInfo();
        this.checkSuperUser();
        this.checkForStartupWarning();
      }
    },
    companyArray(newVal, oldVal) {
      this.updateCompanies(newVal);
    },
    loggedInNoCompanies(newVal, oldVal) {
      if (newVal) this.loadUserInfo();
    },
    activeStoreUsers(val, oldVal) {
      var changed = val.length != oldVal.length;

      if (!changed) {
        // check if new item in val that's not present in oldVal
        val.forEach((v) => {
          var hasMatch = false;
          oldVal.forEach((ov) => {
            if (this.userInfosEqual(v, ov)) {
              hasMatch = true;
              return;
            }
          });
          if (!hasMatch) {
            // new item
            changed = true;
            return;
          }
        });
      }
      if (!changed) {
        // check other way round
        oldVal.forEach((ov) => {
          var hasMatch = false;
          val.forEach((v) => {
            if (this.userInfosEqual(ov, v)) {
              hasMatch = true;
              return;
            }
          });
          if (!hasMatch) {
            // item removed
            this.$helpers.log(this, "active store user removed");
            changed = true;
            return;
          }
        });
      }
      if (changed) {
        this.updateOnlineUserState();
      }
    },
  },
  created() {
    window.menubar = this;
  },
  mounted() {
    this.updateMdReleaseVersion();
    this.initViewMode();
    if (this.supportsHTML5Storage()) {
      this.localStorageSupported = true;
      this.$store.commit(
        "setNightMode",
        localStorage.getItem("uimode") === "2"
      );
    }
    let jwt = false;
    if (this.localStorageSupported) {
      //get JWT from localstorage if it exists, store it in vuex then delete it from localstorage
      //this is needed for development environments were jwt needs to be set manually because our origin is localhost and cant be gotten from auth iframe
      jwt = localStorage.getItem("md_token");

      if (jwt != undefined) {
        this.$store.commit("setJWT", { jwt: jwt });
        let host = window.location.host;
        if (!this.$helpers.isSafari() && !host.startsWith("localhost")) {
          localStorage.removeItem("md_token");
        }
      }
    }

    let view = this;

    //let jwtqs = this.getQueryStringValue("jwt");
    let jwtqs = this.getJwtParam();
    //console.log('JWT FROM QUERY PARAM:');
    //console.log(jwtqs);

    if (!this.$helpers.isBlank(jwtqs)) {
      //console.log("SET MD TOKEN");
      jwt = jwtqs;
      localStorage.setItem("md_token", jwtqs);
      this.$store.commit("setJWT", { jwt: jwtqs });
    }

    if (this.$helpers.isSafari()) {
      console.log("MD loading on Safari");
      if (jwt && jwt != "null") {
        let now = new Date().getTime() / 1000; // current time in seconds
        var redirect = false;
        var auth_ts = localStorage.getItem("auth_ts");
        if (auth_ts && auth_ts != undefined && auth_ts != "null") {
          console.log("Auth timestamp found");
          var age = now - auth_ts;
          console.log("Auth token is " + Math.trunc(age / 60) + " minutes old");
          if (age > this.authValidity) {
            console.log(
              "JWT older then allowed validity of " +
                this.authValidity +
                " seconds, removing token from storage"
            );
            localStorage.removeItem("md_token"); // redirect to check logged in user
            redirect = true;
          }
        } else {
          console.log("No auth timestamp found, removing token from storage");
          localStorage.removeItem("md_token");
          redirect = true;
        }
        if (redirect) {
          console.log("Setting auth timestamp");
          localStorage.setItem("auth_ts", now);
          // redirect to mdauth for tokencheck
          console.log("Redirecting to MD Auth service at:");
          console.log(this.loginUrl);
          //location.href = this.loginUrl; TODO UNCOMMENT
        } else {
          view.login();
        }
      } else {
        //console.log('Else block');
        window.location = this.loginUrl;
      }
    } else {
      if (!view.$helpers.isBlank(view.$store.state.jwt)) {
        view.login();
      } else {
        //console.log('2nd Else block');
        window.location = this.loginUrl;
      }
    }

    // support chat bot bubble
    window.onload = function () {
      let frame = document.getElementById("authframe");

      // some browser (don't remember which one) throw exception when you try to access
      // contentWindow for the first time, it work when you do that second time
      try {
        view.authframe = frame.contentWindow;
      } catch (e) {
        view.authframe = frame.contentWindow;
      }

      window.onmessage = function (e) {
        if (e.origin === "https://account.meindienstplan.at") {
          let response = e.data;
          //console.log(response);
          if (response.key === "md_token") {
            console.log("got token from account server");
            view.$store.commit("setJWT", { jwt: response.data });
            if (
              !view.$helpers.isBlank(view.$store.state.jwt) &&
              !view.$store.state.loggedIn
            ) {
              view.login();
            }
          }
        }
      };
      // request JWT from auth iframe
      view.authframe.postMessage(
        JSON.stringify({ key: "md_token", method: "get" }),
        "*"
      );
    };
  },
  methods: {
    checkForStartupWarning() {
      if (!this.warningShown && this.$helpers.isSafari()) {
        this.$refs["modal-startup"].show();
        this.warningShown = true;
      }
    },
    closeStartupModal() {
      this.$refs["modal-startup"].hide();
      this.warningShown = true;
    },
    closeNoPermissionsModal() {
      this.$refs["modal-nopermissions"].hide();
    },
    compareAlphaNum(a, b) {
      var reA = /[^a-zA-Z]/g;
      var reN = /[^0-9]/g;
      var aA = a.label.replace(reA, "");
      var bA = b.label.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(a.label.replace(reN, ""), 10);
        var bN = parseInt(b.label.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    },

    OpenUserMenu($event) {
      let newsCallback = this.loggedInNoCompanies
        ? null
        : () => {
            view.navigateTo("employeedatarequestoverview");
          };
      let eventLogCallback = this.loggedInNoCompanies
        ? null
        : () => {
            VueEventBus.$emit("toggle-eventlog", true);
          };
      let view = this;
      this.$helpers.OpenPopup({
        type: "menudetails",
        componentState: {
          pictureUrl: view.my_image,
          name: view.userFullname,
          News: newsCallback,
          MyAccount: () => {
            window.location = "https://account.meindienstplan.at";
          },
          EventLog: eventLogCallback,
          SignOut: view.logout,
          eventNumber: view.eventNumber,
        },
        expanded: true,
        noScroll: true,
        elRelative: $event.currentTarget,
        pointerDirection: 0,
      });
    },
    isActive(link) {
      var cur = this.$router.currentRoute;
      return cur.name === link.name;
    },
    updateOnlineUserState() {
      let entries = {};
      let hiddenList = this.activeStoreUsers.slice();
      if (!this.$store.state.isSuperUser) {
        hiddenList = hiddenList.filter((u) => !u.hidden);
      }
      let usersFiltered = hiddenList;
      let view = this;
      usersFiltered.sort((a, b) => {
        return view.$helpers.getMomentFromStringTZ(a.date) >
          view.$helpers.getMomentFromStringTZ(b.date)
          ? 1
          : -1;
      });
      usersFiltered = usersFiltered.slice(0, 10);
      usersFiltered.forEach((u) => {
        entries[u.id] = {
          key: u.id,
          label: "",
          value: u.name,
          type: "text",
        };
      });

      if (hiddenList.length > 10) {
        entries["-"] = {
          key: "-",
          label: "",
          value: "...",
          type: "text",
        };
      }
      this.OnlineUserState.componentState.entries = Object.assign({}, entries);
    },
    userInfosEqual(a, b) {
      var objectsAreSame = true;
      for (var propertyName in a) {
        if (a[propertyName] !== b[propertyName]) {
          objectsAreSame = false;
          break;
        }
      }
      return objectsAreSame;
    },
    initViewMode() {
      var mode = localStorage.getItem("uimode");
      let body = document.getElementsByTagName("body")[0];
      if (mode != undefined) {
        mode = parseInt(mode);
        switch (mode) {
          case 1:
            body.classList.add("daymode");
            break;
          case 2:
            body.classList.add("nightmode");
            break;
          default:
            body.classList.add("daymode");
        }
      } else {
        mode = 1;
        body.classList.add("daymode");
        localStorage.setItem("uimode", mode);
      }
    },
    toggleDarkMode() {
      var mode = 0;
      let body = document.getElementsByTagName("body")[0];
      if (body.classList.length > 0) {
        var cur = body.classList[0];
        if (cur == "nightmode") {
          body.classList.remove("nightmode");
          body.classList.add("daymode");
          mode = 1;
        } else if (cur == "daymode") {
          body.classList.remove("daymode");
          body.classList.add("nightmode");
          mode = 2;
        }
      } else {
        mode = localStorage.getItem("uimode");
        if (mode != undefined) {
          mode = parseInt(mode);
          switch (mode) {
            case 1:
              body.classList.add("daymode");
              break;
            case 2:
              body.classList.add("nightmode");
              break;
            default:
              body.classList.add("daymode");
          }
        } else {
          mode = 1;
          body.classList.add("daymode");
        }
      }
      localStorage.setItem("uimode", mode);
      this.$store.commit("setNightMode", mode === 2);
    },
    loadRoles: function () {
      const url = "/api/sec/roles/getUserRoles";
      /*return new Promise((resolve, reject) => {
        resolve(true);
      });*/

      return this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url,
      })
        .then((response) => {
          const roles = response.data;
          /*for (let i = 0; i < response.data.length; i++) {
             if (!roles[response.data[i].roleId]) {
               roles[response.data[i].roleId] = [];
             }
             roles[response.data[i].roleId].push(
               response.data[i].roleId
             );
           }*/

          this.$store.commit("setRoles", { roles });

          return "SUCCESS";
        })
        .catch(function (error) {
          return new Promise((resolve, reject) => {
            reject(error);
          });
        });
    },
    updateSelectedStores(stores) {
      let ids = [];
      let map = {};
      this.storeArray.forEach((s) => {
        ids.push(s.id);
        map[s.id] = s;
      });
      let selected = [];

      if (stores != undefined) {
        stores.forEach((s) => {
          if (ids.includes(s.id)) {
            selected.push(map[s.id]);
          }
        });
        if (selected.length == 0) {
          console.log("NO STORES??? Selecting all stores for you.");
          selected = this.storeArray;
        }
        this.saveSelectedStores(selected);
      } else {
        // select all if no saved filter found in local storage
        selected = this.storeArray;
        this.saveSelectedStores(selected);
      }
      return new Promise((resolve, reject) => {
        resolve(selected);
      });
    },
    saveSelectedStores(stores) {
      this.selectedStores = stores;
      localStorage.setItem(
        "selectedStores",
        JSON.stringify({ stores: stores })
      );
      this.$store.commit("setSelectedStores", { selectedStores: stores });
    },
    checkSuperUser: function () {
      let view = this;
      let url = "/api/sec/isSuperuser";
      let params = {};
      return this.axios({
        method: "get",
        params: params,
        headers: { AUTHORIZATION: "Bearer " + this.$store.state.jwt },
        url: url,
      })
        .then((response) => {
          console.log("Superuser CHECK: Success - You are Superuser");
          return new Promise((resolve, reject) => {
            view.$store.commit("setIsSuperUser", { isSuperUser: true });
            resolve("SUCCESS");
          });
        })
        .catch(function (error) {
          console.log("Superuser CHECK: Forbidden - You are not a Superuser");
          return new Promise((resolve, reject) => {
            view.$store.commit("setIsSuperUser", { isSuperUser: false });
            resolve("SUCCESS");
          });
        });
    },
    updateCompanies(companies) {
      let view = this;
      if (companies.length == 0) {
        this.$refs["modal-nopermissions"].show();
        view.loggedInNoCompanies = true;
      } else {
        let canUsePreselectedCompanyId = false;
        if (view.$store.state.companyId) {
          Object.values(companies).forEach((e) => {
            if (e.id == view.$store.state.companyId) {
              canUsePreselectedCompanyId = true;
            }
          });
        }
        if (view.$store.state.companyId && canUsePreselectedCompanyId) {
          console.log("selected company id: " + view.$store.state.companyId);
        } else {
          let first = companies[0];
          console.log("auto selecting company id: " + first.id);
          view.$store.commit("setCompanyId", { companyId: first.id });
          view.$store.commit("setCompanyData", { storeData: first });
        }
      }
      view.updateCompaniesDropdown(companies);
    },
    updateCompaniesDropdown(companies) {
      let view = this;
      view.processed = [];
      let selectedItem = {};
      companies.forEach((comp) => {
        let name = comp.name;

        if (name.length > 40) {
          name = name.substring(0, 40) + "...";
        }
        let entry = { label: name, id: comp.id, description: comp.description };
        if (entry.id == view.$store.state.companyId) {
          selectedItem = entry;
          view.$store.commit("setCompanyData", { companyData: entry });
        }
        view.processed.push(entry);
      });

      view.processed.sort(view.compareAlphaNum);
      view.dropdownStoreState = {
        toggled: false,
        displayedItems: [],
        input: "",
        selectedItem: selectedItem,
        items: this.processed,
        selectFirst: false,
        onceSelected: function ($event, item) {
          if (view.$store.state.companyId != item.id) {
            var name = view.$route.name;
            view.$store.commit("setCompanyId", { companyId: item.id });
            view.$store.commit("setCompanyData", { storeData: item });
            view.refresh(true);
            view.$router
              .push({
                name: name,
                params: {
                  companyId: view.$store.state.companyId,
                  tab: "company",
                },
              })
              .catch(() => {});
          } else {
            console.log("selected company not changed");
          }
        },
        noBorder: true,
      };
      view.$forceUpdate();
    },
    showStoreFilter($event) {
      console.log("Showing store filter popup...");
      let view = this;

      let dataEntries = [];
      this.storeArray.forEach((s) => {
        let label = s.name;
        if (s.description != undefined && s.description != "")
          label += " (" + s.description + ")";
        dataEntries.push({
          label: label,
          key: s.id,
          hidden: false,
          type: "bool",
          value:
            this.selectedStores.filter((elem) => {
              return elem.id == s.id;
            }).length > 0,
        });
      });

      this.$helpers.OpenPopup({
        elRelative: $event.currentTarget,
        type: "datafill",
        componentState: {
          entries: dataEntries,
          selectCallback: function (result, datafill) {
            datafill.$parent.locked = false;
            let selected = [];
            view.storeArray.forEach((s) => {
              if (s.id in result && result[s.id]) selected.push(s);
            });
            view.saveSelectedStores(selected);
          },
        },
        header: "Stores auswählen",
        remainAfterSelect: false,
        expanded: true,
        centered: false,
        locked: false,
      });
    },
    loadUserInfo: function () {
      return new Promise((resolve, reject) => {
        resolve(true);
      });
      /* let view = this;
                let url = '/api/sec/semi/user/me';
                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "Bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    let userInfo = {
                        firstname: response.data.firstname,
                        lastname: response.data.lastname,
                        image_url:  response.data.profileimage ? response.data.profileimage.url : null,
                        id: response.data.id
                    };
                    view.$store.commit("setUserInfo", {userInfo: userInfo});

                    if(response.data.profileimage){
                        view.my_image = view.userInfo.image_url;
                    }
                }).catch(function (error) {
                    console.log(error);
                }); */
    },
    Init: function (styles) {
      this.styles = styles;
    },
    ToggleCollapse: function ($event) {
      var event = $event;
      event.currentTarget.parentElement.classList.toggle("show");
    },
    OpenNavMenu($event) {
      let view = this;
      let labels = [];
      this.computedIconsMain.forEach((icon) => {
        labels.push({
          text: icon.label,
          type: "block",
          icon: icon.icon,
          click: () => {
            window.open(icon.externalLink, "_blank");
          },
        });
      });
      this.$helpers.OpenPopup({
        type: "listlabel",
        componentState: {
          labels: labels,
        },
        listStyle: true,
        noScroll: true,
        pointerDirection: 0,
        elRelative: $event.currentTarget,
        pointerOffset: -15,
      });
    },
    ToggleDropDown: function (
      $event,
      selection,
      offsetx,
      offsety,
      pointerOffset
    ) {
      if (!selection || selection.length === 0) return;
      var event = $event;
      var box = event.currentTarget.getBoundingClientRect();
      var dropdowns = this.dropdowns;
      if (selection === this.iconsNav && window.innerWidth <= 750) {
        selection = this.iconsNavCollapsed;
      }
      this.dropdowns.push({
        items: selection,
        el: event.currentTarget,
        remainAfterSelect: true,
        toggled: true,
        offsetx: offsetx,
        offsety: offsety,
        posx: box.left + offsetx,
        posy: box.bottom + offsety,
        pointerOffset: pointerOffset,
        onceSelected: function ($eventInner, item, dropdown) {
          if (item.items && item.items.length > 0) {
            var eventInner = $eventInner;
            var boxInner = eventInner.currentTarget.getBoundingClientRect();
            var temp = {
              items: item.items,
              el: eventInner.currentTarget,
              offsetx: offsetx + 130,
              offsety: offsety - 30,
              posx: box.left + offsetx + 130,
              toggled: true,
              posy: boxInner.bottom - 30,
              pointerDirection: 3,
              pointerOffset: pointerOffset,
              parentCallback: function () {
                dropdown.toggled = false;
              },
            };
            dropdowns.push(temp);
          }
        },
      });
    },
    ToggleDropDownMenuNav: function ($event, selection, offsetx, offsety) {
      var event = $event;
      var box = event.currentTarget.getBoundingClientRect();
      var dropdowns = this.dropdowns;
      var temp = {
        el: event.currentTarget,
        offsetx: offsetx,
        offsety: offsety,
        posx: box.left + offsetx,
        posy: box.bottom + offsety,
        items: selection.items,
        toggled: true,
        onceSelected: function ($eventInner, item, dropdown) {
          dropdowns = dropdowns.filter((d) => d !== temp);
        },
      };
      this.dropdowns.push(temp);
      /*this.$refs.dropdown.Init(selection.items, {
                    el: event.currentTarget,
                    posx: box.left + offsetx,
                    posy : box.bottom + offsety,
                });*/
    },
    ToggleDropDownUser: function ($event, user, offsetx, offsety) {
      var event = $event;
      var box = event.currentTarget.getBoundingClientRect();
      this.$refs.dropdown.posx = box.left + offsetx;
      this.$refs.dropdown.posy = box.bottom + offsety;
      this.$refs.dropdown.items = user.items;
      this.$refs.dropdown.onceSelected = function () {
        this.$forceUpdate();
      };
      this.$refs.dropdown.toggle();
    },
    ToggleDropDownLogin: function ($event, user, offsetx, offsety) {
      var event = $event;
      var box = event.currentTarget.getBoundingClientRect();
      this.$refs.dropdownlogin.posx = box.left + offsetx;
      this.$refs.dropdownlogin.posy = box.bottom + offsety;
      this.$refs.dropdownlogin.onceSelected = function () {
        this.$forceUpdate();
      };
      this.$refs.dropdownlogin.toggle();
    },
    navigateTo(destination) {
      // if(this.$router.currentRoute !== destination.name)
      this.$router.push(destination).catch(() => {});
    },
    getJwtParam() {
      let url = window.location.href;
      if (url.includes("jwt=")) {
        let subIndex = url.indexOf("jwt=") + 4;
        return url.substring(subIndex);
      }
      return null;
    },
    getQueryStringValue: function (key) {
      console.log("Extracting query param: " + key);
      let url = new URL(window.location.href);
      //console.log(window.location.href);
      let searchParams = new URLSearchParams(url.search);
      searchParams.forEach((p) => {
        console.log(p);
      });
      return searchParams.get(key);
      //return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
    },
    supportsHTML5Storage: function () {
      try {
        return "localStorage" in window && window["localStorage"] !== null;
      } catch (e) {
        return false;
      }
    },
    login: function () {
      if (!this.$helpers.isBlank(this.$store.state.jwt)) {
        let view = this;
        let url = "/api/sec/login";

        this.axios({
          method: "get",
          headers: {
            AUTHORIZATION: "Bearer " + this.$store.state.jwt,
          },
          url: url,
        })
          .then((response) => {
            console.log("LOGIN Successful");
            //view.$store.commit('setJWT', {jwt: jwt});
            view.refresh(true);
          })
          .catch(function (error) {
            view.refresh(true);
            view.$store.commit("clearJWT");
            if (view.authframe != null) {
              console.log("clearing jwt in auth frame");
              view.authframe.postMessage(
                JSON.stringify({ key: "md_token", method: "remove" }),
                "*"
              );
            }
            if (view.$route.name != "home") {
              console.log("going home");
              view.navigateTo({ name: "landing" });
            }
            /* view.$helpers.error('Fehler', 'Login fehlgeschlagen'); */
            console.log("LOGIN FEHLGESCHLAGEN");
            window.location = view.loginUrl;
          });
      } else {
        console.log("FEHLER LOGIN");
        window.location = this.loginUrl;
      }
    },
    logout: function () {
      localStorage.removeItem("md_token");
      localStorage.removeItem("selected_store");
      localStorage.removeItem("selected_company");

      let sub = this.getSubDomain();
      if (sub === "staging") {
        window.location =
          "https://account.meindienstplan.at/#/logout?redirect=stagingpromo";
      } else if (sub === "development") {
        window.location =
          "https://account.meindienstplan.at/#/logout?redirect=devpromo";
      } else {
        window.location =
          "https://account.meindienstplan.at/#/logout?redirect=promo";
      }
    },
    refresh: function (force = false) {
      console.log("REFRESH");
      let view = this;
      this.$emit("menubar-loading");
      view.$helpers
        .GetCompanyGroupsArray(force)
        .then((companyGroups) => {
          console.log(companyGroups);
          view.updateCompanies(companyGroups);
          console.log("Has companies: " + !view.loggedInNoCompanies);

          /*
                       if(!view.loggedInNoCompanies){
                           view.$helpers.GetStoresArray(force).then((stores) => {
                               view.$helpers.GetSelectedStores().then((selectedStores) => {
                                   console.log(selectedStores);
                                   view.updateSelectedStores(selectedStores);
                                   view.$emit('menubar-ready');
                               });
                           });
                           return view.$helpers.GetCompanySettings();
                       }*/
        })
        .then((success) => {
          return view.loadRoles();
        })
        .then((success) => {
          return view.checkSuperUser();
        })
        .then((success) => {
          view.$store.commit("setLoggedIn", { loggedIn: true });
          view.$helpers.LoadMaps();

          // view.navigateTo({name: 'filesMain'});
        })
        .catch((error) => {
          //Something went wrong => maybe user doesnt have permission for selected store
          // => clear localstorage
          console.log("SOMETHING WENT WRONG");

          localStorage.removeItem("selected_store");
          localStorage.removeItem("selected_company");
          view.$store.commit("setCompanyId", { companyId: null });
          view.checkForStartupWarning();
          //TODO: navigate to a startpage but iwthout auto login
        });
    },
    getSubDomain: function () {
      let full = window.location.host;
      //window.location.host is subdomain.domain.com
      let parts = full.split(".");
      return parts[0];
    },
    updateMdReleaseVersion: function () {
      let mdrelease = undefined;
      let host = "";
      let view = this;
      if (window.location.href.includes("localhost")) {
        host = "http://localhost";
      } else {
        let sub = this.getSubDomain();
        if (sub === "staging") {
          host = "https://development.meindienstplan.at";
        } else if (sub === "development") {
          host = "https://development.meindienstplan.at";
        } else {
          host = "https://web.meindienstplan.at";
        }
      }
      /*
                this.axios.get(host + '/mdrelease').then((response) => {
                    mdrelease = response.data.replace(/(\r\n|\n|\r)/gm, "");
                    view.mdrelease = mdrelease;
                    let savedMdrelease = localStorage.getItem('mdrelease');
                    if(savedMdrelease != mdrelease){
                        localStorage.setItem('mdrelease', mdrelease);
                        if(savedMdrelease != null && savedMdrelease != undefined){
                            // inform user of updated release and provide link to changelog article
                            let changelogUrl = "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/topic/8691dce5-e491-4431-954b-1baff4435f65/article/1256554497";
                            view.$helpers.OpenAlert({header: 'MEIN DIENSTPLAN - UPDATE INFO', description: 'Wir haben MEINDIENSTPLAN für euch auf Version v' + mdrelease + ' aktualisiert, welche neuen Funktionen im Detail dazugekommen sind findest du im Changelog in unserem Hilfecenter.', disableAccept: true, cancelLabel: 'Schließen', externalLabel: 'Changelog öffnen', externalUrl: changelogUrl, enableExternal: true});
                        }
                    }
                });
                */
      /*
                this.axios.get(host + '/mdversion').then((response) => {
                    view.mdversion = response.data.replace(/(\r\n|\n|\r)/gm, "");
                });
                */
    },
    openAbout() {
      /*
                let view = this;
                this.$helpers.OpenPopup({
                    type: 'aboutpopup',
                    componentState: {
                        mdrelease: view.mdrelease,
                        mdversion: view.mdversion
                    },
                    centered: true,
                    expanded: true,
                });*/
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu-bar {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 55px;
  background: var(--menu-bar);
  z-index: 1000;
  padding: 5px;
}

.menu-bar > * {
  float: left;
}

.icons-main {
  border-radius: 5px;
  position: relative;
  display: inline-block;
  height: 30px;
  width: 30px;
  cursor: pointer;
}

.icons-main .icon {
  border-radius: 5px;
  height: 25px;
  width: 25px;
  cursor: pointer;
  margin: 10px 0px 0px 10px;
  display: inline-block;
}

.icons-main.fixed {
  padding: 10px;
  cursor: default;
}

.icons-main.fixed .icon-visibility-container {
  cursor: default;
}

.icons-main.fixed .icon,
.icons-main.fixed .fas {
  cursor: default;
  display: none;
}

.icons-main.fixed .icon:first-child {
  display: inline-block;
}

.icons-nav,
.icons-left {
  position: absolute;
  left: 60px;
  bottom: 15px;
  height: 25px;
  margin: auto;
  /* width: 340px; */
  text-align: left;
}

.icons-nav > .button:nth-last-child(2) {
  margin: 0px 23px 0px 10px;
}

.icons-nav > .button:nth-last-child(1):before {
  position: absolute;
  content: "";
  height: 25px;
  width: 1px;
  top: 0;
  bottom: 0;
  left: -15px;
  margin: auto;
  background: none;
  border-right: 1px solid var(--contrast-2);
  border-radius: 0;
  pointer-events: none;
}

.icons-nav > .button:nth-last-child(2):after {
  position: absolute;
  content: "";
  height: 25px;
  width: 1px;
  top: 0;
  bottom: 0;
  right: -15px;
  margin: auto;
  background: none;
  border-right: 1px solid var(--contrast-2);
  border-radius: 0;
  pointer-events: none;
}

.icons-left {
  left: 285px !important;
}

.icons-left .fa-cog {
  margin-right: 10px;
  transform: translateY(1px);
  float: left;
  margin-top: 4px;
}

.icons-left .dividerh {
  display: none;
}

.icons-selection {
  position: absolute;
  /*left: 695px;*/
  left: 583px;
  margin: auto;
  bottom: 15px;
  height: 25px;
  width: 270px;
  padding-top: 5px;
}

.icons-selection > * {
  float: left;
  margin-right: 5px;
}

.icons-selection > .label {
  margin-top: -2px;
}

.icons-selection > .fas {
  margin-right: 5px;
  margin-left: 1px;
  font-size: 16px;
}

.icons-selection .dropdown-search {
  width: 180px;
  margin-top: -6px;
  margin-left: 8px;
  position: relative;
}

.icon-main-mz,
.icon-main-mp,
.icon-main-md {
  background: url(/logo.png);
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
}

.nightmode .icon-app-switch {
  background: url(/img/btn_app_switch_light.png);
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
}

.daymode .icon-app-switch {
  background: url(/img/btn_app_switch.png);
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
}

.icon-app-switch {
  transition: 0.2s;
}

.icon-app-switch:hover {
  filter: brightness(300%);
}

.login {
  position: absolute;
  font-size: 14px;
  top: 15px;
  font-weight: 600;
  right: 5px;
}

.login > * {
  /*color: #ffffff;*/
  float: left;
  position: relative;
  margin: 0 12px 0px 5px;
  transition: 0.2s;
  cursor: pointer;
}

.login > *:hover {
  color: #555555;
}

.login > .fa-bars {
  font-size: 20px;

  margin-top: -2px;
}

.login .fa-calendar-alt,
.login .fa-lightbulb {
  top: -2px;
}

.login .user-logged {
  padding-left: 30px;
  padding-top: 8px;
  position: relative;
  margin-top: -6px;
}

.login .user-logged:hover .label {
  color: var(--bg);
}

.login .user-logged .label {
  pointer-events: none;
  transition: 0.2s;
}

.login .user-logged .picture {
  position: absolute;
  left: 0;
  top: 6px;
  border-radius: 100px;
  height: 25px;
  width: 25px;
  background-position: 50% 50%;
  background-size: 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: 0.2s;
}

.login .user-logged:hover .picture {
  box-shadow: 0 0 0 2.5px var(--contrast-4);
}

.login .user-logged .label {
  font-size: 13px;
  color: var(--contrast-4);
  margin-right: -0.1px;
  letter-spacing: 0.4px;
}

.login .fas {
  position: relative;
  color: var(--contrast-4);
  float: left;
  position: relative;
  margin: 0 5px;
  transition: 0.2s;
  cursor: pointer;
  font-size: 20px;
  height: 25px;
  width: 25px;
  padding-top: 5px;
}

.login .fas:hover {
  color: var(--bg);
}

.login .fas .notification,
.menu .notification {
  position: absolute;
  background: #f43535;
  color: #ffffff;
  height: 16px;
  width: 16px;
  font-size: 8px;
  text-align: center;
  top: -8px;
  right: -8px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login .fas .notification.big,
.menu .notification.big {
  height: 17px;
  width: 17px;
  font-size: 8px;
  text-align: center;
  top: -8px;
  right: -8px;
}

.login .fa-bell {
  font-size: 16px;
}

.login .fa-sign-out-alt {
  margin-top: 2px;
}

.login .icon {
  font-size: 16px;
  height: 25px;
  width: 25px;
  margin-top: 0px;
  margin-right: 4px;
}

.login .label {
  color: var(--contrast-4);
}

.login .cog-correction {
  padding-top: 3px;
  margin-right: -2px;
}

.login .bell-correction {
  padding-top: 5px;
}

.menu-bar .picture {
  transition: 0.2s;
  cursor: pointer;
  height: 25px;
  width: 25px;
}

.menu-bar .picture:hover {
  box-shadow: 0 0 0 2px var(--contrast-7);
}
</style>
